<template>
    <div class="tree-outer" :style="{ width: showStretch ? `calc(${treeOuterWidth}px + 25px)` : `${treeOuterWidth}px` }">
        <div
            class="tree-container"
            :style="{ width: showStretch ? 'calc(100% - 20px)' : '100%' }"
            v-loading="treeLoading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
        >
            <div class="button-wrap" v-if="treeToolBar">
                <el-button
                    class="leader-common-button"
                    size="medium"
                    @click="handleAddTreeNode"
                    type="primary"
                    >新增</el-button
                >
                <el-button
                    class="leader-common-button"
                    size="medium"
                    @click="handleEditTreeNode"
                    type="primary"
                    >修改</el-button
                >
                <el-button
                    class="leader-common-button"
                    size="medium"
                    @click="handleDelTreeNode"
                    type="primary"
                    >删除</el-button
                >
            </div>
            <div class="title-wrap" v-if="title">
                <span class="split-line"></span>
                {{ title }}{{ cascadingVar ? "：" : "" }}
                <el-checkbox
                    @change="cascadingVarChange"
                    v-show="cascadingVar"
                    v-model="check"
                    style="color: #fff"
                    >级联选择</el-checkbox
                >
            </div>
            <el-input
                class="tree_search_inp"
                v-show="showSearch"
                placeholder="输入关键字进行过滤"
                v-model="filterText"
            >
            </el-input>
            <div class="treeOuterWrapper" :style="{width: '100%', height: showSearch ? 'calc(100% - 40px)' : '100%' }">
                <el-scrollbar
                    :style="{
                        height: title ? 'calc(100% - 90px)' : treeToolBar ? 'calc(100% - 116px)' : '100%'
                    }"
                >
                    <el-tree
                        ref="tree"
                        :data="treeData"
                        :key="keyTree"
                        :highlight-current="highlightCurrent"
                        :node-key="nodeKey"
                        :check-strictly="checkStrictly"
                        :check-on-click-node="isCheckClick"
                        :expand-on-click-node="false"
                        :default-expand-all="defaultExpandAll"
                        :default-expanded-keys="defaultExpandedKeys"
                        :props="defaultProps"
                        :default-checked-keys="defaultCheckKeys"
                        :show-checkbox="showCheckbox"
                        @node-expand="nodeExpand"
                        @node-collapse="nodeCollapse"
                        @node-click="handleNodeClick"
                        @check="handleCheckBoxClick"
                        :accordion="accordion"
                        :style="{ height: treeHeight }"
                        :filter-node-method="filterNode"
                    >
                        <span class="span-ellipsis" slot-scope="{ node, data }">
                            <!-- <i class="el-icon-success" style="font-size:20px color:red;margin-right:2px;"></i> -->
                            <span :title="node.label">{{ node.label }}</span>
                            <span
                                class="right-icon"
                                v-if="
                                    showIcon &&
                                        showIconKeyValue &&
                                        data[showIconKey] == showIconKeyValue
                                "
                                >√</span
                            >
                            <span
                                class="right-icon"
                                v-if="
                                    showIcon &&
                                        !showIconKeyValue &&
                                        data[showIconKey]
                                "
                                >√</span
                            >
                        </span>
                    </el-tree>
                </el-scrollbar>
            </div>
        </div>
        <div
            v-if="showStretch"
            class="stretchArea"
            :style="{ width: showStretch ? '25px' : 0 }"
        >
            <i class="iconfont icon-left-circle-fill" @click="handleResetWidth()"></i>
            <i class="iconfont icon-right-circle-fill" @click="handleStretchWidth()"></i>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            keyTree: + new Date(),
            filterText: "",
            check: false,
            treeOuterWidth: 280,
            expandedNodeList: [],
        };
    },
    props: {
        showIconKeyValue: {
            type: String
        },
        showIconKey: {
            type: String
        },
        showIcon: {
            type: Boolean,
            default: false
        },
        highlightCurrent: {
            type: Boolean,
            default: true
        },
        treeData: {
            //树数据
            type: Array
        },
        treeLoading: {
            //树loading状态
            type: Boolean,
            default: false
        },
        treeToolBar: {
            //是否显示新增修改删除按钮
            type: Boolean,
            default: true
        },
        defaultProps: {
            //默认树节点属性设置
            type: Object,
            default: () => {
                return {
                    children: "children",
                    label: "label"
                };
            }
        },
        nodeKey: {
            //指定唯一标识字段
            type: String,
            default: "id"
        },
        //树节点名，默认point_name
        nodeKeyName: {
            type: String,
            default: "point_name"
        },
        showCheckbox: {
            //是否显示checkbox
            type: Boolean,
            default: false
        },
        checkStrictly: {
            // 遵循父子不互相关联的做法
            type: Boolean,
            default: false
        },
        defaultCheckKeys: {
            //默认checkbox选中
            type: Array,
            default: () => {
                return [];
            }
        },
        isSingle: {
            //checkbox  是否单选
            type: Boolean,
            default: false
        },
        // showIcon: {
        //     //是否在树节点前显示图标（一般用于区分虚、实点）
        //     type: Boolean,
        //     default: false
        // },
        //是否显示查询框，默认显示
        showSearch: {
            type: Boolean,
            default: true
        },
        isCheckClick: {
            //是否在点击节点的时候选中节点
            type: Boolean,
            default: true
        },
        defaultExpandAll: {
            //默认是否展开全部子节点
            type: Boolean,
            default: false
        },
        defaultExpandedKeys: {
            //默认展开指定子节点
            type: Array,
            default: () => {
                return [];
            }
        },
        title: {
            //树标题
            type: String,
            default: ""
        },
        treeHeight: {
            type: String,
            default: "100%"
        },
        cascadingVar: {
            type: Boolean,
            default: false
        },
        accordion: {
            type: Boolean,
            default: false
        },
        showStretch: {
            //是否显示右侧的拉伸按钮,大部分=true时需要定义方法handleStretchClick来调整父级宽度，根据父组件样式决定
            type: Boolean,
            default: true
        }
    },

    watch: {
        treeData: {
            handler(newValue) {
                this.treeData = newValue;
            },
            deep: true,
            immediate: true
        },
        checkStrictly: {
            handler(newValue) {
                console.log(newValue);
                this.checkStrictly = newValue;
                this.check = !this.checkStrictly;
            },
            deep: true,
            immediate: true
        },
        filterText(val) {
            if (val) {
                this.$refs.tree.filter(val);
            } else {
                this.keyTree = + new Date()
                //没有进行过展开和折叠操作的树，默认展开初始化时展开的节点，否则展开expandedNodeList里记录的节点
                if(this.expandedNodeList && this.expandedNodeList.length) this.defaultExpandedKeys = this.expandedNodeList;
                //没有checkbox的树，之前选中的节点要回显一下
                if(!this.showCheckbox && this.defaultCheckKeys && this.defaultCheckKeys.length) {
                    this.$nextTick(() => {
                        this.$refs.tree.setCurrentKey(this.defaultCheckKeys[0]);
                    })
                }
            };
        }
    },
    methods: {
        nodeExpand(data, node, item) {
            this.expandedNodeList.push(data[this.nodeKey]);
           // console.log('.....nodeExpand:' , data, this.expandedNodeList)
        },
        nodeCollapse(data, node, item) {
            this.expandedNodeList = this.expandedNodeList.filter(item => item != data[this.nodeKey]);
           // console.log('.....nodeCollapse:' , data, this.expandedNodeList)
        },
        /**
         * 数节点点击事件
         * 默认参数共三个参数，依次为：传递给 data 属性的数组中该节点所对应的对象、节点对应的 Node、节点组件本身。
         */
        handleNodeClick(data, node) {
            this.selectTree = data;
            if (node && node.hasOwnProperty("level"))
                this.selectTree.treeLevel = node.level;
            this.$emit("handleTreeNodeClick", data);
            let nodeKey = this.nodeKey;
            this.$nextTick(() => {
                if (!this.showCheckbox) {
                    this.$refs.tree.setCurrentKey(data[nodeKey]);
                }
            });
        },
        handleCheckBoxClick(data) {
            this.selectTree = data;
            this.$emit("handleCheckBoxClick", data);
            let nodeKey = this.nodeKey;
            this.$nextTick(() => {
                if (this.isSingle) {
                    let nodeKeys = this.$refs.tree.getCheckedKeys();
                    // console.log("one check tree", nodeKeys, data[nodeKey]);
                    if (nodeKeys.indexOf(data[nodeKey]) == -1) {
                        this.$refs.tree.setCheckedKeys([]);
                    } else {
                        this.$refs.tree.setCheckedKeys([data[nodeKey]]);
                    }
                } else {
                    let nodeKeys = this.$refs.tree.getCheckedKeys();
                    console.log("more check tree -- nodeKeys:", nodeKeys);
                    this.$refs.tree.setCheckedKeys(nodeKeys);
                    //  this.defaultExpandedKeys = nodeKeys;
                }
            });
        },
        /**
         * 添加数节点
         */
        handleAddTreeNode() {
            this.$emit("handleAddTreeNode", this.selectTree);
        },
        /**
         * 编辑树节点
         */
        handleEditTreeNode() {
            this.$emit("handleEditTreeNode", this.selectTree);
        },
        /**
         * 删除树节点
         */
        handleDelTreeNode() {
            this.$emit("handleDelTreeNode", this.selectTree);
        },
        //重置树宽度
        handleResetWidth() {
            this.treeOuterWidth = 280;
            this.$emit("handleStretchClick", this.treeOuterWidth);
        },
        //伸展树宽度，100px/次
        handleStretchWidth() {
            if (this.treeOuterWidth < 500) {
                this.treeOuterWidth += 100;
                this.$emit("handleStretchClick", this.treeOuterWidth);
            }
        },
        /**
         * 级联复选框值改变回调函数
         */
        cascadingVarChange(e) {
            this.$emit("update:checkStrictly", !e);
        },
        //树名称过滤
        filterNode(value, data) {
            if (!value) return true;
                return data[this.nodeKeyName].indexOf(value) !== -1;
        }
    }
};
</script>
<style lang="scss">
.tree-outer {
    // width: 280px;
    height: 100%;
    display: flex;
    flex-flow: row nowrap;
    .tree-container {
        //  width: 100%;
        height: 100%;
        //    min-width: 280px;
        // overflow-y: auto;
        background: transparent;
        .el-scrollbar__view {
            margin-bottom: 40px;
            box-sizing: border-box;
        }
        .button-wrap {
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            margin-bottom: 20px;
        }
        .el-tree-node__label {
            @include ellipsis();
            text-align: left;
            color: #fff;
        }
        .title-wrap {
            text-align: left;
            font-size: 16px;
            width: 100%;
            height: 50px;
            line-height: 50px;
            padding-left: 10px;
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            align-items: center;
            color: #fff;
            justify-content: left;
            border-bottom: 1px solid #778f99;
            margin-bottom: 10px;
            .title {
                padding-right: 10px;
            }
            .split-line {
                display: inline-block;
                background: #56fcff;
                width: 4px;
                height: 14px;
                border-radius: 2px;
                margin-right: 10px;
            }
        }
        .right-icon {
            color: #ff6637;
            position: relative;
            font-size: 0.3rem;
            top: -2px;
            left: 5px;
        }
    }
    .stretchArea {
        color: #fff;
        display: flex;
        flex-flow: column wrap;
        justify-content: center;
        .icon-left-circle-fill {
            font-size: 20px;
           color: #06B4F9;
            cursor: pointer;
        }
        .icon-right-circle-fill {
            font-size: 20px;
           color: #06B4F9;
            margin-top: 30px;
            cursor: pointer;
        }
    }
}
.el-tree {
    background: transparent;
    // color: #fff;
}
.span-ellipsis {
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: block;
    color: #ffffff;
    font-size: 14px;
}
.tree_search_inp {
    margin-bottom: 5px;
    .el-input__inner {
        border: 1px solid #277ea3;
        color: #fff;
        background-color: transparent !important;
    }
    .el-input__inner:hover {
        border: 1px solid #56fbff;
    }
    input::-webkit-input-placeholder {
        color: #aab2bd;
    }
}
.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
    background-color: #1a6292;
}
.el-tree-node__content:hover {
    background-color: #1a6292;
}
.el-tree__empty-text {
    color: #fff;
}
.tree-container {
    width: 100%;
    height: 100%;
    min-width: px2Rem(280px);
    z-index: 0;
    // overflow-y: auto;
    background: transparent;
    .treeOuterWrapper {
        overflow-y: hidden;
    }
    .el-scrollbar__view {
        margin-bottom: 40px;
        box-sizing: border-box;
    }
    .button-wrap {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        margin-bottom: 20px;
    }
    .el-tree-node__label {
        @include ellipsis();
        text-align: left;
        color: #fff;
    }
    .title-wrap {
        text-align: left;
        font-size: 16px;
        width: 100%;
        height: 50px;
        line-height: 50px;
        padding-left: 10px;
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        align-items: center;
        color: #fff;
        justify-content: left;
        border-bottom: 1px solid #dedede;
        margin-bottom: 10px;
        .title {
            padding-right: 10px;
        }
        .split-line {
            display: inline-block;
            background: #56fcff;
            width: 4px;
            height: 14px;
            border-radius: 2px;
            margin-right: 10px;
        }
    }
    .right-icon {
        color: #ff6637;
        position: relative;
        font-size: 0.3rem;
        top: -2px;
        left: 5px;
    }
}
</style>
